import axios from 'axios';
import App from '@/assets/app.js';
import Api from '@/assets/api.js';

axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
// axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8';

axios.defaults.baseURL = Api.url

//POST傳參序列化(添加請求連結器)
axios.interceptors.request.use((config) => {
	//發送請求前
	// if (config.method === 'get') {
	// 	config.data = true;
	// }
	// else{
	// config.baseURL = 'http://202.130.113.149:3785/';
	// config.baseURL = 'https://hk.qmisit.com:3785/';
	// config.baseURL = 'http://192.168.31.93:6785/';
	// }
	return config;
}, (error) => {
	console.log('錯誤傳參')
	return Promise.reject(error);
});
//响应拦截器
// axios.interceptors.response.use(
// 	response => {
// 		// console.log(response.data.code)
// 		// //拦截响应 统一处理
// 		if (response.data.code) { //失效
// 			if (response.data.code === 3000) {
// 				App.oTool.warningT(response.data.qmismsg);
// 				location.href = '/'
// 			}
// 		}
// 		return response
// 	}, error => {
// 		//接口错误状态处理，无响应处理

// 		// App.oTool.warningT(error.data.qmismsg);
// 		return Promise.reject(error) //接口返回的错误信息
// 	})


//返回一個Promise(發送post請求)login用
export function fetchLoginPost(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params).then(response => {
			if (Object.is(response.status, 200)) {
				resolve(response.data);
			}
		}, err => {
			App.oTool.warningT('服務器錯誤請聯繫管理員')
			reject(err);
		}).catch((error) => {
			reject(error);
		});
	})
}


//返回一個Promise(發送post請求)
export function fetchPost(url, params, header) {
	return new Promise((resolve, reject) => {
		axios.defaults.headers.common["token"] = header.token;
		axios.post(url, Object.assign(params)).then(response => {
			// if (Object.is(response.status, 200)) {
			// 	if (Object.is(response.data.qmiscode, 3000)) {
			// 		setTimeout(() => {
			// 			location.href = '/';
			// 		}, 1500);
			// 	}
			// 	resolve(response.data);
			// }
			resolve(response.data);
		}, err => {
			App.oTool.warningT('服務器錯誤請聯繫管理員')
			reject(err);
		}).catch((error) => {
			reject(error);
		});
	})
}

////返回一个Promise(发送get请求) pdf
export function fetchGetPdf(url) {
		console.log(url);
		axios({
			method: 'post',
			url: Api.getpdfable,
		}).then()
	
		return new Promise((resolve, reject) => {
			axios({
				method: 'GET',
				url: url,
				responseType: 'blob'
			}).then((res) => {
				resolve(res.data);
			}, err => {
				// App.oTool.warningT('服務器錯誤請聯繫管理員');
				reject(err);
			}).catch((error) => {
				// App.oTool.warningT('服務器錯誤請聯繫管理員');
				reject(error);
			})
		})
}


export default {
	fetchLoginPost,
	fetchPost,
	fetchGetPdf
}
